import React from 'react';
import { Box, Grid, MenuItem, Skeleton } from '@mui/material';

const WorkspaceSkeleton = () => {
  return (
    <>
      {Array.from(new Array(7)).map((_, index) => (
        <MenuItem key={index}>
          <Grid container alignItems='center'>
            <Box ml={2}>
              <Skeleton variant='text' width={220} height={38} />
            </Box>
          </Grid>
        </MenuItem>
      ))}
    </>
  );
};

export default WorkspaceSkeleton;
